import { useEffect, RefObject } from 'react';

export const useClickOutside = (
  ref: RefObject<HTMLDivElement>,
  isOpen: boolean,
  onClose: () => void,
) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [ref, isOpen, onClose]);
};
